function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.793 16L9.5 3.707a1 1 0 0 1 1.414-1.414l12.647 12.646a1.5 1.5 0 0 1 0 2.122L10.914 29.707A1 1 0 0 1 9.5 28.293L21.793 16z"
});

var SvgCarouselRight = function SvgCarouselRight(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "feced4d4782a226eca46cb3a0cc81ab0.svg";
export { SvgCarouselRight as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/carousel-right.svg
// module id = null
// module chunks = 